import * as React from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
};
var SvgGillyHicksMonogram = function SvgGillyHicksMonogram(_ref) {
  var fill = _ref.fill,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? null : _ref$height,
    width = _ref.width;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    fill: fill,
    width: width,
    height: height,
    role: "img"
  }, /*#__PURE__*/React.createElement("title", null, "gilly hicks"), /*#__PURE__*/React.createElement("path", {
    d: "M14.002.186a13.817 13.817 0 1 1-.005 27.633A13.817 13.817 0 0 1 14.003.186Zm0 1.781c-6.646 0-12.035 5.389-12.035 12.035 0 6.647 5.389 12.036 12.035 12.036a12.035 12.035 0 0 0 12.036-12.036c0-6.646-5.389-12.035-12.036-12.035Zm4.813 14.746 1.219.766a7.015 7.015 0 0 1-12.33 0l1.219-.766a5.635 5.635 0 0 0 9.892 0Zm1.077-8.095-1.915 2.297h1.613l-4.034 3.494 1.692-2.634h-1.216l2.047-3.157h1.813Zm-9.921.025c.763-.04 1.5.287 1.982.88l.04.047-.625.617-.05-.062a1.623 1.623 0 0 0-1.315-.607c-.984 0-1.672.755-1.672 1.813 0 1.058.676 1.802 1.645 1.802a1.316 1.316 0 0 0 1.422-1.24H9.882v-.83h2.45v.087c.008.092.013.181.02.263 0 1.551-.956 2.594-2.381 2.594-1.673 0-2.575-1.34-2.575-2.676 0-1.335.885-2.688 2.575-2.688Z"
  }));
};
SvgGillyHicksMonogram.propTypes = propTypes;

export { SvgGillyHicksMonogram as default };
//# sourceMappingURL=GillyHicksMonogram.js.map
